import { LightMode, Wallet } from '@mui/icons-material';
import {
  Box,
  Menu,
  MenuItem,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useStore from 'src/store/cns';

const TLNavbar = () => {
  const mode = useStore(state => state.mode);
  const toggleTheme = useStore(state => state.toggleTheme);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const logoSrc = isMobile
    ? `${process.env.PUBLIC_URL}/img/camino_logo.png`
    : `${process.env.PUBLIC_URL}/img/camino_logo_${mode}.png`;

  const handleLogout = () => {
    handleMenuClose();
    logout();
    navigate('/cns');
  };

  const wallet = useStore(state => state.wallet);
  const logout = useStore(state => state.logout);

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        maxWidth: '1536px',
      }}
    >
      <Box
        sx={{
          borderRight: '1px solid',
          borderColor: 'rgba(145, 158, 171, 0.24)',
          flex: '1 1 25%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          onClick={() => navigate('/cns')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            py: 1,
          }}
        >
          <img
            src={logoSrc}
            alt="Camino"
            style={{
              height: isMobile ? '24px' : '28px',
              width: 'auto',
              marginRight: '10px',
            }}
          />
          <Typography variant={isMobile ? 'body1' : 'h4'} color="info.main">
            Name Service
          </Typography>
        </Box>
      </Box>

      {isMobile ? (
        <Box display="flex" alignItems="center">
          <Button
            onClick={() => {
              navigate('/wallet');
            }}
          >
            <Wallet />
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            flex: '3 1 75%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            onClick={toggleTheme}
            sx={{
              mx: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LightMode
              sx={{
                mx: 0.5,
                color: 'text.primary',
              }}
            />
            <Typography color="text.primary">
              {mode === 'dark' ? 'Dark' : 'Light'}
            </Typography>
          </Button>
          <Box
            sx={{
              mx: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: 'success.light',
                mx: 1,
              }}
            />
            <Typography color="text.primary">Base Sepolia</Typography>
          </Box>

          <Box
            sx={{
              mx: 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <Wallet sx={{ mx: 0.1 }} />
            {wallet ? (
              <>
                <Typography onClick={handleMenuOpen}>
                  {wallet.address.slice(0, 6)} ... {wallet.address.slice(-4)}
                </Typography>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                onClick={() => {
                  navigate('/wallet');
                }}
              >
                <Typography variant="body1" color="text.primary">
                  Login
                </Typography>
              </Button>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default React.memo(TLNavbar);
